function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -432.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sketch",
  transform: "translate(0.000000, 404.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#FDAD00",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#FFD06B",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.9560785,20.9774171 C26.9590968,20.9584356 26.9590968,20.9391283 26.9560785,20.9201469 L22.3541602,14.6681521 C22.2607592,14.5467655 22.1118144,14.475711 21.9539933,14.4772515 L14.9510742,14 L7.94815505,14.4772515 C7.82649236,14.4853203 7.71235074,14.5363686 7.6280216,14.620427 L3.04611164,20.8819668 L3.04611164,20.958327 C2.96507711,21.1257056 2.99233948,21.3226472 3.11614084,21.4642136 L14.6209366,34.8272559 C14.7159661,34.9366755 14.8571582,35 15.0060971,35 C15.155036,35 15.2962281,34.9366755 15.3912577,34.8272559 L26.8960534,21.4642136 C27.0085385,21.3248938 27.0316033,21.1378405 26.9560785,20.9774171 Z M20,23 L15,33 L10,23 L20,23 Z M20,21 L10,21 L15,15 L20,21 Z M9,21 L6,21 L8.45454545,18 L9,21 Z M21,21 L21.5454545,18 L24,21 L21,21 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})))));

var SvgSketch = function SvgSketch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSketch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sketch.df03c3bf.svg";
export { ForwardRef as ReactComponent };